<template>
  <div class="news-page">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 定制化多档位方案 -->
    <section class="section plan-section">
      <div class="container">
        <div class="plan-wrapper">
          <div class="plan-image">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAghoeszwYoqOrU2QIw6QY4oQU.png" alt="年节礼包">
          </div>
          <div class="plan-content">
            <h2 class="plan-title">定制化多档位方案 随心选择</h2>
            <p class="plan-desc">结合不同采购预算、送礼人群差异，科学划分多个礼品档位，从亲民实用款到高端尊享款全覆盖，档位清晰、搭配合理。</p>
            <p class="plan-detail">可自由组合粮油干货、特色零食、时令生鲜、养生好物、节庆礼盒、日用好物等多类单品，支持自由增减品类、替换单品、调整配比，告别固定礼盒的局限性，完全贴合你的个性化需求。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 业务动态 -->
    <section class="section news-section">
      <div class="container">
        <div class="section-label">COMPANY NEWS</div>
        <h2 class="section-heading">业务动态</h2>
        <p class="news-desc">
          年节关爱全覆盖，满足不同预算需求，拥有正品授权及资质，假一赔三，从前到售后得到全面保障各节推出多档位礼包。
          覆盖粮油副食、家用电器、家具厨卫、文体户外、休闲零食、个护美妆等多品类，为员工提供更丰富的兑换选择。
        </p>
        <div class="news-banner">
          <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgxf67zwYow7v03Qcw_g84hQU!1500x1500.png" alt="业务动态">
        </div>
      </div>
    </section>

    <!-- 高性价比 贴心组合 -->
    <section class="section combo-section">
      <div class="container">
        <div class="combo-wrapper">
          <div class="combo-sidebar">
            <div class="combo-label">COMBINATION</div>
            <h3 class="combo-title">高性价比 贴心组合</h3>
            <p class="combo-desc">多档位阶梯定价，批量采购更有优势，一站式搭配打包，省去自行挑选组合的繁琐；统一包装、集中配送，省时省力，高效完成节日福利与礼赠筹备。</p>
          </div>
          <div class="combo-items">
            <div class="combo-item">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgnYW8zwYo3LiF0QYwjgY4ggU!300x300.png" alt="米面粮油">
              <div class="combo-item-name">米面粮油</div>
            </div>
            <div class="combo-item">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgp4a8zwYowtuk_wYw-AU4uAU!300x300.png" alt="清洁好物">
              <div class="combo-item-name">清洁好物</div>
            </div>
            <div class="combo-item">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg4Ie8zwYo9Y-ADjCdBjj0BA!300x300.png" alt="厨房用具">
              <div class="combo-item-name">厨房用具</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

export default {
  name: 'News',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      bannerImage: require('../src/assets/lb.png')
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif; color: #353535; line-height: 1.6; }

.news-page { background: #fff; }

/* Banner */
.banner {
  height: 800px;
  background-size: cover;
  background-position: 50% 50%;
}

/* 通用 */
.section { padding: 60px 0; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}
.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 30px;
}

/* 定制化多档位方案 */
.plan-wrapper {
  display: flex;
  gap: 30px;text-align: left;
  align-items: flex-start;
}
.plan-image {
  flex: 0 0 400px;
}
.plan-image img {
  width: 100%;
  border-radius: 4px;
}
.plan-content {
  flex: 1;
}
.plan-title {
  font-size: 28px;
  color: #353535;
  margin-bottom: 20px;
}
.plan-desc {
  font-size: 20px;
  line-height: 2em;
  color: #666;
  margin-bottom: 20px;
}
.plan-detail {
  font-size: 20px;
  line-height: 2.3em;
  color: #666;
}

/* 业务动态 */
.news-section {
  background: #fafafa;
}
.news-desc {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  color: #353535;
  max-width: 1100px;
  margin: 0 auto 30px;padding:  0 100px;
}
.news-banner {
  text-align: center;
}
.news-banner img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

/* 高性价比 贴心组合 */
.combo-section {
  background: #fff;
}
.combo-wrapper {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}
.combo-sidebar {text-align: left;
  flex: 0 0 250px;
}
.combo-label {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}
.combo-title {
  font-size: 30px;
  color: #c40000;
  font-weight: bold;
  margin-bottom: 20px;
  line-height: 1.3;
}
.combo-desc {
  font-size: 14px;
  color: #353535;
  line-height: 1.8;
}
.combo-items {
  flex: 1;
  display: flex;
  gap: 30px;
}
.combo-item {
  flex: 1;
  text-align: center;
}
.combo-item img {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.combo-item-name {
  font-size: 16px;
  font-weight: bold;
  color: #353535;
}

@media (max-width: 768px) {
  .plan-wrapper {
    flex-direction: column;
  }
  .plan-image {
    flex: none;
  }
  .combo-wrapper {
    flex-direction: column;
  }
  .combo-items {
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// src/News.vue